import { getEnvRequired } from '../../shared/utilities/env';
import { ApiClient } from '../shared/api/client';

import { serializeNotificationArrayFromAPI } from './serializer';
import { Notification, NotificationJSONAPIResponse } from './types';

const apiClient = new ApiClient(true);
const REQUEST_MANAGER_API_URL = getEnvRequired('REQUEST_MANAGER_API_URL');

export async function getNotifications(): Promise<Notification[]> {
    const response = await apiClient.get<NotificationJSONAPIResponse>(
        `${REQUEST_MANAGER_API_URL}/notifications`,
    );

    return serializeNotificationArrayFromAPI(response);
}

export async function markNotificationAsRead(notificationId: string): Promise<void> {
    await apiClient.post(`${REQUEST_MANAGER_API_URL}/notifications/${notificationId}/read`);
}

export async function markNotificationAsUnread(notificationId: string): Promise<void> {
    await apiClient.delete(`${REQUEST_MANAGER_API_URL}/notifications/${notificationId}/read`);
}
